import React, { ReactNode, useLayoutEffect, useRef } from 'react';

import classNames from 'classnames';

import { TelegramUser } from '@api';
interface TelegramLoginButtonProps {
  className?: string;
  onAuth: (user: TelegramUser) => void;
  asChild?: boolean;
  buttonSize?: 'large' | 'medium' | 'small';
  children?: ReactNode;
  disabled?: boolean;
}

const TelegramLoginButton = ({
  className,
  buttonSize = 'large',
  onAuth,
  asChild,
  disabled,
  children,
}: TelegramLoginButtonProps) => {
  const rootElRef = useRef<HTMLDivElement>(null);
  const botName = process?.env?.NEXT_PUBLIC_TELEGRAM_BOT_NAME;

  useLayoutEffect(() => {
    window.onTelegramAuth = (user: TelegramUser) => {
      onAuth(user);
    };

    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.setAttribute('data-telegram-login', botName || '');
    script.setAttribute('data-size', buttonSize);
    script.setAttribute('data-request-access', 'write');
    script.setAttribute('data-userpic', 'false');
    script.setAttribute('data-radius', '8');
    script.setAttribute('data-onauth', 'onTelegramAuth(user)');

    script.async = true;
    rootElRef?.current?.appendChild(script);

    return () => {
      rootElRef?.current?.removeChild(script);
      delete window.onTelegramAuth;
    };
  }, [botName, buttonSize, onAuth]);

  if (!botName) {
    return null;
  }

  return (
    <div
      className={classNames(
        {
          'relative [&>iframe]:absolute [&>iframe]:!size-full [&>iframe]:opacity-[0.01]': asChild,
          '[&>iframe]:pointer-events-none': disabled,
        },
        className,
      )}
      ref={rootElRef}
    >
      {children}
    </div>
  );
};

export default TelegramLoginButton;
